import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewAiTrackGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_TRACK,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAiTrackGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_TRACK,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createAiTrackGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_TRACK,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewAiMilestoneGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_MILESTONE,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAiMilestoneGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_MILESTONE,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewAiTaskGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_TASK,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAiTaskGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_PROJECT_TASK,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewAiAgentGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_AGENTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createAiAgentGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_AGENTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAiAgentGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.AI_AGENTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
